import CitySEOHead from "@/components/feature/CitySEOHead";
import FranklinTNHeroSection from "./components/HeroSection";
import FranklinTNStickyNav from "./components/StickyNav";
import FranklinTNProcessingTimeSection from "./components/ProcessingTimeSection";
import FranklinTNServicesSection from "./components/ServicesSection";
import FranklinTNLocalAreaSection from "./components/LocalAreaSection";
import FranklinTNTravelTimingSection from "./components/TravelTimingSection";
import FranklinTNDestinationsSection from "./components/DestinationsSection";
import FranklinTNTestimonialsSection from "./components/TestimonialsSection";
import FranklinTNAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FranklinTNComparisonSection from "./components/ComparisonSection";
import FranklinTNMistakesSection from "./components/MistakesSection";
import FranklinTNHowItWorksSection from "./components/HowItWorksSection";
import FranklinTNFAQSection, { faqs } from "./components/FAQSection";
import FranklinTNHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FranklinTNFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport Franklin TN", description: "Urgent passport processing for Franklin and Williamson County travelers with immediate international departure needs, as fast as 24 hours." },
  { name: "Expedited Passport Renewal Franklin TN", description: "Fast passport renewal for Cool Springs executives, Brentwood families, and Williamson County residents — 2-9 business days." },
  { name: "New Passport Franklin TN", description: "First-time passport application assistance for Franklin-area residents with acceptance facility scheduling support." },
  { name: "Child Passport Franklin TN", description: "Minor passport services for Williamson County families, with parental consent guidance and step-by-step acceptance clerk support." },
  { name: "Lost Stolen Passport Replacement Franklin TN", description: "Fast replacement of lost or stolen passports for Franklin and Williamson County residents." },
  { name: "Corporate Passport Services Franklin TN", description: "Expedited passport processing for Cool Springs corporate executives and business travelers with compressed international travel timelines." },
];

export default function FranklinTNPage() {
  return (
    <>
      <CitySEOHead
        city="Franklin"
        state="Tennessee"
        stateAbbr="TN"
        route="/franklin-tn"
        title="Emergency Passport Franklin, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Franklin, TN and Williamson County — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Cool Springs executives, Brentwood families, Spring Hill residents, and Williamson County travelers. No Nashville agency lines required."
        geoPlacename="Franklin, Tennessee"
        geoPosition="35.9251;-86.8689"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <div className="font-sans">
        <FranklinTNHeroSection />
        <FranklinTNStickyNav />
        <FranklinTNProcessingTimeSection />
        <FranklinTNLocalAreaSection />
        <FranklinTNServicesSection />
        <FranklinTNTravelTimingSection />
        <FranklinTNDestinationsSection />
        <FranklinTNTestimonialsSection />
        <FranklinTNAcceptanceFacilitiesSection />
        <FranklinTNComparisonSection />
        <FranklinTNMistakesSection />
        <FranklinTNHowItWorksSection />
        <FranklinTNFAQSection />
        <FranklinTNHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/franklin-tn" state="TN" />
        <FranklinTNFinalCTA />
      </div>
    </>
  );
}